import { render, staticRenderFns } from "./InstitutionProfile.vue?vue&type=template&id=3495687c&scoped=true&"
import script from "./InstitutionProfile.vue?vue&type=script&lang=js&"
export * from "./InstitutionProfile.vue?vue&type=script&lang=js&"
import style0 from "./InstitutionProfile.vue?vue&type=style&index=0&id=3495687c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3495687c",
  null
  
)

export default component.exports